import { render, staticRenderFns } from "./IncidentDetails.v2.vue?vue&type=template&id=433afcf4&"
import script from "./IncidentDetails.v2.vue?vue&type=script&lang=js&"
export * from "./IncidentDetails.v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports